import classNames from 'classnames';
import { Button } from '../../../ui';
import st from './index.module.css';
import Link from 'next/link';

const Hero = () => {
  const handleScroll = () => {
    const section = document.getElementById('black-offer');
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="bg-white py-[48px]">
      <div className="container flex flex-col items-center gap-[48px]">
        <div className="flex flex-col items-center gap-[24px]">
          <h2 className="text-center font-[500] text-[32px] md:text-[48px] leading-[39px] md:leading-[62px] text-[#000000]">
            Շատ թվային գոլեր
            <br /> World Cup 2026-ին
          </h2>
          <div className="md:text-[32px] text-[24px] font-bold text-[#000000] px-[8px] py-[6px] bg-[#9EBF91] max-w-max md:leading-[39px] leading-[29px]">
            ապրիլի 10 - հուլիսի 10
          </div>
        </div>
        <div className="flex flex-col items-center gap-[50px] md:pt-[68px] pt-0 relative w-full ">
          <div className="w-full absolute top-0 md:block hidden h-auto z-10">
            <img src="/images/offers/varota.png" alt="Hero Background" className="object-cover h-full w-full" />
          </div>
          <div className="flex md:flex-row flex-col justify-center gap-[24px] relative z-20 w-full overflow-hidden">
            <div className="bg-[#000000] px-[24px] py-[32px] flex flex-col gap-[24px] lg:h-[420px] h-[470px] lg:w-[445px] w-full">
              <div className="flex flex-col gap-[16px]">
                <h3 className="text-[24px] font-semibold text-[#9EBF91] leading-[31px]">1. Limited Time Offer for NN</h3>
                <span className="text-[18px] text-white font-semibold leading-[23px]"> World Cup Interactive Banner</span>
              </div>
              <div className="px-[24px] py-[10px] bg-white text-[#000000] flex flex-col gap-[10px]">
                <span className="lg:text-[32px] text-[28px] font-bold leading-[42px]">2 000 000 AMD</span>
                <span className="text-[18px] font-thin leading-[23px]">2 500 000 view</span>
              </div>
              <div className="text-white text-[16px] font-thin">
                World Cup թեմատիկ ինտերակտիվ բաններ Յուրաքանչյուր բանների համար <span className="font-bold">1 բրենդի հաստատում</span>
              </div>
              <Button variant="greenOffer" className="md:w-[280px] w-full hover:md:w-[270px]" onClick={handleScroll}>
                Ստանալ բանների դեմո
              </Button>
            </div>
            <div className="hide_scrollbar overflow-x-auto md:overflow-x-hidden max-w-full">
              <div className="min-w-max md:min-w-full flex flex-row md:flex-wrap flex-nowrap gap-[14px] md:justify-center justify-start md:h-[420px] h-auto lg:w-[445px] w-full">
                <Link href="https://ads.caramel.am/banners/templates/snack/snacks/">
                  <div className="w-[213px] h-[200px] cursor-pointer relative">
                    <img
                      src="/images/offers/bool.png"
                      alt="bool"
                      className={classNames(
                        'w-[52px] h-[52px] absolute z-30 transform top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] cursor-pointer',
                        st.pulse
                      )}
                    />
                    <img src="/images/offers/item-1.png" alt="Offer 1" className="object-cover w-full h-full" />
                  </div>
                </Link>
                <Link href="https://ads.caramel.am/banners/templates/world-cup-template-widget/">
                  <div className="w-[213px] h-[200px] cursor-pointer relative">
                    <img
                      src="/images/offers/bool.png"
                      alt="bool"
                      className={classNames(
                        'w-[52px] h-[52px] absolute z-30 transform top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] cursor-pointer',
                        st.pulse
                      )}
                    />
                    <img src="/images/offers/item-2.png" alt="Offer 2" className="object-cover w-full h-full" />
                  </div>
                </Link>
                <Link href="https://ads.caramel.am/banners/templates/snack/snack-fullpage-chips/">
                  <div className="w-[213px] h-[200px] cursor-pointer relative">
                    <img
                      src="/images/offers/bool.png"
                      alt="bool"
                      className={classNames(
                        'w-[52px] h-[52px] absolute z-30 transform top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] cursor-pointer',
                        st.pulse
                      )}
                    />
                    <img src="/images/offers/item-3.png" alt="Offer 3" className="object-cover w-full h-full" />
                  </div>
                </Link>
                <Link href="https://ads.caramel.am/banners/templates/snack/snack-fullpage-beer/">
                  <div className=" w-[213px] h-[200px] cursor-pointer relative">
                    <img
                      src="/images/offers/bool.png"
                      alt="bool"
                      className={classNames(
                        'w-[52px] h-[52px] absolute z-30 transform top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] cursor-pointer',
                        st.pulse
                      )}
                    />
                    <img src="/images/offers/item-4.png" alt="Offer 4" className="object-cover w-[103%] h-[103%]" />
                  </div>
                </Link>
              </div>
            </div>
          </div>
          <div className="flex md:flex-row flex-col gap-[30px]">
            <div className="bg-[#000000] px-[24px] py-[32px] flex flex-col gap-[24px] lg:h-[420px] h-[470px] lg:w-[445px] w-full relative">
              <div className="flex flex-col gap-[16px]">
                <h3 className="text-[24px] font-semibold text-[#9EBF91] leading-[31px]">2. TikTok ads</h3>
                <span className="text-[18px] text-white font-semibold leading-[23px]"> Champion of Gen Z in Digital World</span>
              </div>
              <div className="px-[24px] py-[10px] bg-white text-[#000000] flex flex-col gap-[10px]">
                <span className="lg:text-[32px] text-[28px] font-bold leading-[42px]">1 500 000 AMD</span>
                <span className="text-[18px] font-thin leading-[23px]">1 500 000 view</span>
              </div>
              <div className="text-white text-[16px] font-thin">
                <span className="font-bold">Առավելություն`</span> 10% զեղչ մենեջմենթի համար
              </div>
              <Button variant="greenOffer" className="md:w-[220px] w-full hover:md:w-[210px]" onClick={handleScroll}>
                Ստանալ առաջարկ
              </Button>

              <img
                src="/images/offers/color-bool.png"
                alt="bool"
                className="w-[96px] h-[109px] absolute z-30 transform bottom-[-55px] right-[-24px] md:block hidden "
              />
            </div>
            <div className="bg-[#000000] px-[24px] py-[32px] flex flex-col gap-[24px] lg:h-[420px] h-[470px] lg:w-[445px] w-full relative">
              <div className="flex flex-col gap-[16px]">
                <h3 className="text-[24px] font-semibold text-[#9EBF91] leading-[31px]">3. Youtube ads</h3>
                <span className="text-[18px] text-white font-semibold leading-[23px]"> Champion of 2026 in Digital world Armenia</span>
              </div>
              <div className="px-[24px] py-[10px] bg-white text-[#000000] flex flex-col gap-[10px]">
                <span className="lg:text-[32px] text-[28px] font-bold leading-[42px]">1 500 000 AMD</span>
                <span className="text-[18px] font-thin leading-[23px]">1 200 000 view</span>
              </div>
              <div className="text-white text-[16px] font-thin">
                <span className="font-bold">Առավելություն`</span> հայերեն գովազդի հաստատում
              </div>
              <Button variant="greenOffer" className="md:w-[220px] w-full hover:md:w-[210px]" onClick={handleScroll}>
                Ստանալ առաջարկ
              </Button>
              <img
                src="/images/offers/color-bool.png"
                alt="bool"
                className="w-[96px] h-[109px] absolute z-30 transform bottom-[-55px] right-[-24px] md:block hidden "
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
